import { Flex, Typography } from "antd"

export const BalancesStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        This is likely the section you'll use most often. Here, you can:
      </Typography.Text>

      <ul>
        <li>
          View all available cryptocurrencies and fiat currencies, along with
          your current balances
        </li>

        <li>Top Up – Add funds to your balance</li>
        <li>Convert – Exchange crypto to crypto or fiat</li>
        <li>Withdraw – Withdraw your funds</li>
      </ul>
    </Flex>
  )
}
